export enum USER_FEATURE_FLAGS {
  PICTOFITCMS_APPROVE_REQUEST = 'PICTOFITCMS_APPROVE_REQUEST',
  PICTOFITCMS_REJECT_REQUEST = 'PICTOFITCMS_REJECT_REQUEST',
  RR_EMPLOYEE = 'RR_EMPLOYEE',
}
